import { graphql, type Environment } from 'react-relay/legacy';
import commitMutation from 'relay-commit-mutation-promise';

import {
    type UpdateSellerApplicationLeadInput as Input,
    type updateSellerApplicationLeadMutation as Mutation,
    type updateSellerApplicationLeadMutation$data as Response,
} from './__generated__/updateSellerApplicationLeadMutation.graphql';

const mutation = graphql`
    mutation updateSellerApplicationLeadMutation($input: UpdateSellerApplicationLeadInput!) {
        UpdateSellerApplicationLead(input: $input) {
            leadId
        }
    }
`;

export const updateSellerApplicationLeadMutation = (
    environment: Environment,
    input: Input
): Promise<Response> =>
    commitMutation<Mutation>(environment, {
        mutation,
        variables: { input },
    });
